// React & React Hooks
import { useContext } from "react";

// Third-party libraries
import { useTranslation } from "react-i18next";
import { Box, Card, Grid, Stack, Typography } from "@mui/material";

// Project constants
import urlConstant from "../../constants/urlConstants";
import dataConstant from "../../constants/dataConstants";

// Shared / reusable components
import DataCardGrid from "../../shared-components/DataCardGrid/DataCardGrid";

// Services / utilities
import { httpPost } from "../../services/commonService";

// Context / Providers
import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";

function DualTeamBonusCommission() {
  const { accessToken, impersonateEmail } = useContext(AuthenticationContext);
  const { t } = useTranslation();

  const columns = [
    {
      key: "StrCommissionDate",
      label: t("DualTeamBonusRpt.CommissionDate"),
      type: "date",
      isFilterVisible: true,
    },
    {
      key: "CommissionAmount",
      label: t("DualTeamBonusRpt.CommissionAmount"),
      type: "money",
      isFilterVisible: true,
    },
    {
      key: "CommissionType",
      label: t("DualTeamBonusRpt.CommissionType"),
      type: "text",
      isFilterVisible: true,
    },
    {
      key: "CommissionStatus",
      label: t("DualTeamBonusRpt.Status"),
      type: "text",
      isFilterVisible: true,
      statusIcon: true,
    },
    {
      key: "CommissionDescription",
      label: t("DualTeamBonusRpt.Description"),
      type: "text",
      isFilterVisible: false,
    },
  ];

  const fetchDataFunction = async ({
    page,
    pageSize,
    search,
    filters,
    sortKey,
    sortDirection,
  }) => {
    const getDualTeamComissionList =
      urlConstant.Reports.DualTeamBonusCommissionReport;
    const pagingInfo = {
      PageNumber: page,
      RowsPerPage: pageSize,
      CommonSearchText: search,
      SortColumns: {
        SortColumnName: sortKey,
        SortOrder: sortDirection,
      },
      Filter: {
        CommissionStatusFilter: filters?.CommissionStatus,
        CommissionDateFilter: filters?.StrCommissionDate,
        CommissionTypeFilter: filters?.CommissionType,
        CommissionAmountFilter: filters?.CommissionAmount,
      },
    };
    const requestBody = {
      PagingInfoVM: pagingInfo,
    };
    try {
      const response = await httpPost(
        getDualTeamComissionList,
        requestBody,
        true,
        false,
        accessToken,
        impersonateEmail
      );
      if (response?.Value?.Status === dataConstant.APIResponseStatus.Success) {
        return {
          data: response.Value.Data.Data,
          totalCount: response.Value.Data.TotalCount,
        };
      } else {
        return { data: [], totalCount: 0 };
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Typography
          color="secondary.light"
          display={{ xs: "flex", sm: "none" }}
          variant="h4"
          fontWeight={600}
          fontSize={"24px"}
        >
          {t("Reports")}
        </Typography>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: {
                xs: "20px",
                sm: "25px 30px",
              },
              background: theme.palette.background.cardGradient,
              border: "1px solid var(--headerbg)",
              borderRadius: "20px",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Grid container spacing={2}>
                <Typography
                  color="secondary.light"
                  variant="h4"
                  fontWeight={600}
                >
                  {t("Dual Team Bonus Commission")}
                </Typography>
                <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                  <DataCardGrid
                    onFetchData={fetchDataFunction}
                    columns={columns}
                    defaultItemsPerPage={4}
                    defaultColumnsPerGrid={2}
                    enableExport={true}
                    enablePagination={true}
                    uniqueId="commission-grid"
                  />
                </Grid>
              </Grid>
            </Stack>
          </Card>
        </Box>
      </Box>
    </>
  );
}

export default DualTeamBonusCommission;
